module.exports = __webpack_public_path__ + "img/logo9@2x.e9e72706.png";